import { Fragment } from "react";
import Skeleton from "components/Skeleton/Skeleton";

// Skeleton/Loading Screen
const skeleton = {
  component: Skeleton,
  label: ``,
  icon: Fragment
};

export default skeleton;
